import { AuthStateService } from '@service/auth-state.service';

import AES from 'crypto-js/aes';
import UTF8 from 'crypto-js/enc-utf8';

export class CryptHelper {
  static encrypt(str: string, auth: AuthStateService): string {
    if (!str) {
      return str;
    }
    const sub = auth.getIDToken()?.uid;
    if (!sub) {
      return str;
    }
    return AES.encrypt(str, sub).toString();
  }

  static encryptWithKey(str: string, key: string): string {
    if (!str) {
      return str;
    }
    return AES.encrypt(str, CryptHelper.secureKey(key)).toString();
  }

  static decrypt(str: string, auth: AuthStateService): string {
    if (!str) {
      return str;
    }
    const sub = auth.getIDToken()?.uid;
    if (!sub) {
      return str;
    }
    try {
      return AES.decrypt(str, sub).toString(UTF8);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      return '';
    }
  }

  static decryptWithKey(str: string, key: string): string {
    if (!str) {
      return str;
    }
    try {
      return AES.decrypt(str, CryptHelper.secureKey(key)).toString(UTF8);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      return '';
    }
  }

  private static secureKey(key: string): string {
    return `lat${key}iv`;
  }
}
